import { reactive } from 'vue'

export const chordStore = reactive({
  compatibleChords: [],
  chordProgression: [],
  loadingChords: false,
  showSongs: false,
  similarSongs: []
})